import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FlaskConical, Trophy, User } from 'lucide-react';
import './Navigation.css';

function Navigation() {
  const navItems = [
    { to: '/', icon: Home, label: 'Главная', exact: true },
    { to: '/testing', icon: FlaskConical, label: 'Тесты' },
    { to: '/leaderboard', icon: Trophy, label: 'Топ' },
    { to: '/profile', icon: User, label: 'Я' },
  ];

  return (
    <nav className="navigation-bar">
      <div className="navigation-container">
        {navItems.map(({ to, icon: Icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'active' : ''}`
            }
          >
            <Icon className="nav-icon" size={20} strokeWidth={2} />
            <span className="nav-label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default Navigation;
